module.exports = __webpack_public_path__ + "static/img/newsimg5.b8fa014e.jpg";